export default {
  clean: () => import("/tmp/build_d5a8d3bb/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/tmp/build_d5a8d3bb/layouts/default.vue").then(m => m.default || m)
}